import { render, staticRenderFns } from "./user_profile_info.vue?vue&type=template&id=721aef24&scoped=true"
import script from "./user_profile_info.vue?vue&type=script&lang=js"
export * from "./user_profile_info.vue?vue&type=script&lang=js"
import style0 from "./user_profile_info.vue?vue&type=style&index=0&id=721aef24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721aef24",
  null
  
)

export default component.exports